import React from 'react';
import Header from '../components/sections/Header';
import Hero from '../components/sections/Hero';
import SocialProof from '../components/sections/SocialProof';
import Problem from '../components/sections/Problem';
import Solution from '../components/sections/Solution';
import Services from '../components/sections/Services';
import DemoVideo from '../components/sections/DemoVideo';
import Process from '../components/sections/Process';
import WhyChooseUs from '../components/sections/WhyChooseUs';
import TargetCustomers from '../components/sections/TargetCustomers';
import TechStack from '../components/sections/TechStack';
import PricingTransparency from '../components/sections/PricingTransparency';
import Testimonials from '../components/sections/Testimonials';
import FAQ from '../components/sections/FAQ';
import FinalCTA from '../components/sections/FinalCTA';
import Footer from '../components/sections/Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <SocialProof />
        <Problem />
        <Solution />
        <Services />
        <DemoVideo />
        <Process />
        <WhyChooseUs />
        <TargetCustomers />
        <TechStack />
        <PricingTransparency />
        <Testimonials />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
